import React, { useEffect } from "react";
import HeaderWrapper from "./header.style";
import { iconAppNameNegative } from "helper/constant";
import InputPage from "../common/InputPage";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { serverResponse } from "../../util/fakeServer";
import { setIndexCarousel, isFromInput } from "../../redux/carousel/action";
import { toggleCart } from "../../redux/cart/action";
import ZoomButton from "../leaflet/ZoomButton";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { H_COMPONENTS, logoInterattivoFree } from "../../helper/constant";
import {
  getPager,
  getAnalyticsDevice,
  getAnalyticsUniqueId,
  sendVisit
} from "../../helper/utility";
import Searchbar from "../searchBar/Searchbar";
import { visit, getIp } from "../../services/analytics.services";
import {
  isMobileOnly,
  isTablet,
  isIPad13,
  isBrowser as isDesktop
} from "react-device-detect";
import SearchbarDigit from "../searchBar/SearchbarDigit";

const Header = (props) => {
  useEffect(() => {
    if (serverResponse.config.ga_active && sendVisit()) {
      getIp()
        .then((res) => {
          visit({
            id_cliente: serverResponse.config.client_id,
            id_insegna: serverResponse.config.signboard_id,
            id_utente: serverResponse.config.release_id,
            id_volantino: serverResponse.leaflet.id,
            device: getAnalyticsDevice(
              isMobileOnly,
              isTablet || isIPad13,
              isDesktop && !isIPad13
            ),
            ip_address: res.data.IPv4,
            unique_id: getAnalyticsUniqueId()
          });
        })
        .catch((err) => {
          console.log(err);
          visit({
            id_cliente: serverResponse.config.client_id,
            id_insegna: serverResponse.config.signboard_id,
            id_utente: serverResponse.config.release_id,
            id_volantino: serverResponse.leaflet.id,
            device: getAnalyticsDevice(
              isMobileOnly,
              isTablet || isIPad13,
              isDesktop && !isIPad13
            ),
            ip_address: null,
            unique_id: getAnalyticsUniqueId()
          });
        });
    }
  }, []);

  const { drawerMiniMethod, mini } = props;

  // const searchBarToggle = () => {
  //   setSearchBarOpen(!searchBarOpen);
  // };

  const showMobileSearch =
    props.showMobileSearch &&
    !serverResponse.config.hide_searchbar &&
    props.location.pathname !== "/categories";

  return (
    <HeaderWrapper {...props}>
      <div className="container-fluid" style={{ height: H_COMPONENTS.header }}>
        <div className="row h-100">
          <div className="col-3 p-md-1 p-2 d-lg-none h-100">
            {!serverResponse.config.no_link_to_site && (
              <a
                href="https://www.volantinointerattivo.net/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  id="logo_header"
                  src={logoInterattivoFree}
                  alt="react-logo"
                  style={{ height: "100%" }}
                />
              </a>
            )}
            {serverResponse.config.no_link_to_site && (
              <img src={iconAppNameNegative} alt="react-logo" />
            )}
          </div>
          <div className="col-6 d-lg-none d-flex justify-content-center align-items-center">
            {getPager() === "slider" &&
              props.location.pathname !== "/categories" &&
              props.location.pathname !== "/pages" && (
                <li className="list-inline-item d-flex align-items-center">
                  <InputPage />
                </li>
              )}
          </div>
          <div className="col-3 d-flex align-items-center justify-content-end d-lg-none h-100">
            <button
              style={{
                position: "relative"
              }}
              className="top-header-icon btn"
              id="mobile-grocery"
              onClick={() => props.toggleCart(props.cartReducer.isOpen)}
            >
              {serverResponse.config.send_grocery_list_to_market && (
                <FontAwesomeIcon
                  icon={faShoppingCart}
                  style={{
                    fontSize: "25px",
                    color: "var(--primary-color)"
                  }}
                />
              )}
              {!serverResponse.config.send_grocery_list_to_market && (
                <div id="custom_grocery_button" className="btn">
                  <i
                    className="fas fa-shopping-basket"
                    style={{
                      color: "var(--primary-color)",
                      fontSize: "25px "
                    }}
                  ></i>
                </div>
              )}
              {props.cartReducer.cart.length > 0 && (
                <span
                  style={{ position: "absolute" }}
                  className="custom-mobile-grocery-notification-badge"
                >
                  {props.cartReducer.cart.length}
                </span>
              )}
            </button>
          </div>
          <div className="col-12 d-none d-lg-flex justify-content-center">
            <div className="container-fluid p-0 custom_header_container_fluid">
              <div className="row h-100">
                <div className="col-lg-1 p-0 d-flex align-items-center">
                  <div className="headerBack mb-0" style={{ display: "flex" }}>
                    <div className="drawer-handle-arrow d-none d-lg-block">
                      {mini ? (
                        <button
                          className="top-header-icon c-btn"
                          onClick={drawerMiniMethod()}
                        >
                          <i className="fas fa-arrow-right" />
                        </button>
                      ) : (
                        <button
                          className="top-header-icon c-btn"
                          onClick={drawerMiniMethod()}
                        >
                          <i className="fas fa-arrow-left" />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-10 d-flex align-items-center justify-content-center">
                  {!showMobileSearch &&
                    !serverResponse.config.hide_searchbar &&
                    props.location.pathname !== "/categories" &&
                    (serverResponse.config.global_search ? (
                      <Searchbar {...props} />
                    ) : (
                      <SearchbarDigit {...props} />
                    ))}
                  {getPager() === "slider" &&
                    props.location.pathname !== "/categories" &&
                    props.location.pathname !== "/pages" && (
                      <li className="list-inline-item d-flex align-items-center">
                        <InputPage />
                      </li>
                    )}
                  {props.location.pathname !== "/categories" &&
                    props.location.pathname !== "/pages" && <ZoomButton />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showMobileSearch && (
        <div
          className="d-lg-none px-2 pb-2"
          style={{ height: H_COMPONENTS.mobile_searchbar }}
        >
          {serverResponse.config.global_search ? (
            <Searchbar {...props} mobileSearch />
          ) : (
            <SearchbarDigit {...props} mobileSearch />
          )}
        </div>
      )}
    </HeaderWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    // groceryList: state.groceryList.list,
    carouselIndex: state.carousel,
    cartReducer: state.cartReducer
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    setIndexCarousel,
    isFromInput,
    toggleCart
  })
)(Header);
